import { render, staticRenderFns } from "./CtintMultipleTabCategoryContent.vue?vue&type=template&id=488a85cb&"
import script from "./CtintMultipleTabCategoryContent.vue?vue&type=script&lang=js&"
export * from "./CtintMultipleTabCategoryContent.vue?vue&type=script&lang=js&"
import style0 from "./CtintMultipleTabCategoryContent.vue?vue&type=style&index=0&id=488a85cb&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports